import React from 'react';
import './LegalPages.css';

function AboutPage() {
  return (
    <div className="legal-page">
      <div className="legal-hero">
        <h1>About Discover Vanuatu</h1>
        <p className="last-updated">Your Ultimate Guide to Paradise</p>
      </div>

      <div className="legal-content">
        <section className="legal-section">
          <h2>Welcome to Discover Vanuatu</h2>
          <p>Discover Vanuatu is the premier digital platform connecting visitors and residents with the best businesses, attractions, dining experiences, and services across the beautiful islands of Vanuatu.</p>
          <p>Whether you're planning your dream vacation, looking for local services, or exploring what the islands have to offer, Discover Vanuatu is your comprehensive guide to paradise.</p>
        </section>

        <section className="legal-section">
          <h2>Our Mission</h2>
          <p>Our mission is to empower both locals and visitors by providing easy access to verified business listings, authentic reviews, and valuable information about Vanuatu's diverse offerings. We aim to:</p>
          <ul>
            <li>Connect customers with quality businesses and services</li>
            <li>Promote local enterprises and support economic growth</li>
            <li>Showcase the beauty and culture of Vanuatu</li>
            <li>Provide a user-friendly platform for discovering experiences</li>
            <li>Foster community engagement and trust through authentic reviews</li>
          </ul>
        </section>

        <section className="legal-section">
          <h2>What We Offer</h2>
          <h3>For Visitors & Residents</h3>
          <ul>
            <li><strong>Comprehensive Business Directory:</strong> Browse thousands of businesses across multiple categories</li>
            <li><strong>Interactive Maps:</strong> Find businesses and attractions near you with our integrated mapping feature</li>
            <li><strong>Authentic Reviews:</strong> Read real experiences from other users to make informed decisions</li>
            <li><strong>Search & Filter:</strong> Easily find exactly what you're looking for with advanced search options</li>
            <li><strong>Mobile App:</strong> Access everything on-the-go with our iOS and Android applications</li>
            <li><strong>Weather Updates:</strong> Stay informed about current conditions</li>
            <li><strong>Currency Converter:</strong> Quick conversion tools for international visitors</li>
          </ul>

          <h3>For Business Owners</h3>
          <ul>
            <li><strong>Free Listings:</strong> Get your business discovered at no cost</li>
            <li><strong>Premium Placements:</strong> Enhance visibility with featured listings</li>
            <li><strong>Targeted Advertising:</strong> Reach your ideal customers with our ad platform</li>
            <li><strong>Business Analytics:</strong> Track views, clicks, and customer engagement</li>
            <li><strong>Customer Reviews:</strong> Build trust and credibility through authentic feedback</li>
            <li><strong>Multi-Category Support:</strong> List under multiple relevant categories</li>
          </ul>
        </section>

        <section className="legal-section">
          <h2>Categories We Cover</h2>
          <div className="categories-list">
            <div className="category-col">
              <ul>
                <li>🍽️ Restaurants & Dining</li>
                <li>🏨 Accommodation</li>
                <li>🏖️ Tours & Activities</li>
                <li>🛍️ Shopping</li>
                <li>💼 Professional Services</li>
              </ul>
            </div>
            <div className="category-col">
              <ul>
                <li>🏥 Health & Medical</li>
                <li>💪 Fitness & Wellness</li>
                <li>🚗 Auto & Rentals</li>
                <li>🏦 Banking & Finance</li>
                <li>⛽ Petrol Stations</li>
              </ul>
            </div>
            <div className="category-col">
              <ul>
                <li>🎓 Education</li>
                <li>🔧 Home Services</li>
                <li>🎭 Entertainment</li>
                <li>📱 Technology</li>
                <li>...and many more!</li>
              </ul>
            </div>
          </div>
        </section>

        <section className="legal-section">
          <h2>Our Platform</h2>
          <h3>Website</h3>
          <p>Our responsive website provides a seamless experience across all devices. Browse categories, search for specific businesses, view on interactive maps, and read reviews - all from your desktop or mobile browser.</p>
          
          <h3>Mobile Applications</h3>
          <p>Download our native mobile apps for iOS and Android to access Discover Vanuatu on-the-go. Enjoy:</p>
          <ul>
            <li>Offline access to saved favorites</li>
            <li>Location-based recommendations</li>
            <li>Push notifications for special offers</li>
            <li>Faster, smoother performance</li>
          </ul>
        </section>

        <section className="legal-section">
          <h2>Advertising Opportunities</h2>
          <p>We offer various advertising solutions to help businesses reach their target audience:</p>
          <ul>
            <li><strong>Featured Listings:</strong> Priority placement in search results and category pages</li>
            <li><strong>Banner Advertisements:</strong> Carousel ads on high-traffic pages</li>
            <li><strong>Pop-up Promotions:</strong> Eye-catching promotional opportunities</li>
            <li><strong>Targeted Campaigns:</strong> Category and location-based targeting</li>
            <li><strong>Performance Tracking:</strong> Monitor impressions, clicks, and ROI</li>
          </ul>
          <p>Contact our advertising team at <strong>ads@discovervanuatu.com</strong> to learn more about packages and pricing.</p>
        </section>

        <section className="legal-section">
          <h2>Our Commitment to Quality</h2>
          <p>While we strive to maintain accurate and up-to-date information, we rely on businesses and users to keep listings current. We encourage:</p>
          <ul>
            <li>Business owners to claim and update their listings regularly</li>
            <li>Users to report outdated or incorrect information</li>
            <li>Community members to share authentic reviews and experiences</li>
          </ul>
        </section>

        <section className="legal-section disclaimer">
          <h2>Important Disclaimers</h2>
          <p><strong>Information Accuracy:</strong> While we make efforts to ensure information accuracy, Discover Vanuatu does not verify all business listings or user-submitted content. We are not responsible for any inaccuracies, outdated information, or misleading content.</p>
          
          <p><strong>Third-Party Services:</strong> Listed businesses operate independently. We do not endorse, guarantee, or assume responsibility for the quality, safety, or legality of their products or services.</p>
          
          <p><strong>No Warranties:</strong> Our platform is provided "as is" without warranties of any kind. We do not guarantee uninterrupted service, error-free operation, or that the platform will meet your specific needs.</p>
          
          <p><strong>Limitation of Liability:</strong> Discover Vanuatu shall not be liable for any damages arising from your use of the platform or interactions with businesses listed on our platform.</p>
        </section>

        <section className="legal-section">
          <h2>Join Our Community</h2>
          <p>Discover Vanuatu is more than just a directory - it's a community of locals, visitors, and businesses working together to showcase the best of Vanuatu.</p>
          <ul>
            <li><strong>Users:</strong> Create an account to save favorites, write reviews, and unlock exclusive features</li>
            <li><strong>Businesses:</strong> Claim your free listing and start connecting with customers today</li>
            <li><strong>Contributors:</strong> Help grow our platform by sharing your local knowledge and experiences</li>
          </ul>
        </section>

        <section className="legal-section">
          <h2>Get Started</h2>
          <p>Ready to explore? Here's how to get started:</p>
          <ol>
            <li>Browse our categories to discover businesses and services</li>
            <li>Use the search function to find specific offerings</li>
            <li>View locations on our interactive map</li>
            <li>Read reviews from other users</li>
            <li>Download our mobile app for on-the-go access</li>
            <li>Create an account to unlock additional features</li>
          </ol>
        </section>

        <section className="legal-section">
          <h2>Contact Us</h2>
          <p>Have questions, suggestions, or want to list your business? We'd love to hear from you!</p>
          <p className="contact-info">
            <strong>Email:</strong> info@discovervanuatu.com<br/>
            <strong>Business Inquiries:</strong> business@discovervanuatu.com<br/>
            <strong>Location:</strong> Port Vila, Vanuatu
          </p>
        </section>

        <section className="legal-section">
          <h2>Legal Information</h2>
          <p>By using Discover Vanuatu, you agree to our <a href="/terms-and-conditions">Terms and Conditions</a> and <a href="/privacy-policy">Privacy Policy</a>. Please review these documents to understand your rights and obligations.</p>
        </section>
      </div>
    </div>
  );
}

export default AboutPage;
